import { ExportConfiguration } from '../export/exportConfiguration';

export enum ReorderRuleExportField {
  name = 'name',
  productName = 'productName',
  productNumber = 'productNumber',
  stockLocation = 'stockLocation',
  stockLocationAggregateType = 'stockLocationAggregateType',
  reorderPoint = 'reorderPoint',
  replenishQuantity = 'replenishQuantity',
}

export class ReorderRuleExportConfiguration extends ExportConfiguration<ReorderRuleExportField> {
  static default(companyId: string) {
    return new ReorderRuleExportConfiguration({
      companyId,
      name: '',
      filename: 'ventory_reorder_rule_${TIMESTAMP}',
      mapping: DEFAULT_MAPPING(),
    });
  }
}

const DEFAULT_MAPPING = () => {
  const map = new Map<ReorderRuleExportField, { value: string; index: number }>();
  map.set(ReorderRuleExportField.name, { value: 'Name', index: 0 });
  map.set(ReorderRuleExportField.productNumber, {
    value: 'Product Number',
    index: 1,
  });
  map.set(ReorderRuleExportField.stockLocation, {
    value: 'Stock Location',
    index: 2,
  });
  map.set(ReorderRuleExportField.stockLocationAggregateType, {
    value: 'Stock Location Aggregate Type',
    index: 3,
  });
  map.set(ReorderRuleExportField.reorderPoint, {
    value: 'Reorder Point',
    index: 4,
  });
  map.set(ReorderRuleExportField.replenishQuantity, {
    value: 'Replenish Quantity',
    index: 5,
  });
  return map;
};
